import PaymentForm from '@/features/paymentProcess/PaymentForm';

import RouteProps from '@/types/shared-types';

function PayinPaymentForm({ totalSteps, currencySymbol }: RouteProps) {
  return (
    <PaymentForm totalSteps={totalSteps} currencySymbol={currencySymbol} />
  );
}

export default PayinPaymentForm;
